import React, { useMemo } from "react";
import { TableProps } from "../../types/table";

const TableComponent = <T,>({ columns, data }: TableProps<T>): JSX.Element => {
  const tableHeaders = useMemo(
    () =>
      columns.map((col) => (
        <th
          key={col.header}
          className="px-4 py-2 whitespace-nowrap font-medium text-gray-700"
        >
          {col.header}
        </th>
      )),
    [columns]
  );

  const tableRows = useMemo(
    () =>
      data.map((row, i) => (
        <tr key={i} className="border-t hover:bg-gray-50">
          {columns.map((col, j) => {
            const value = row[col.accessor];
            return (
              <td key={j} className="px-4 py-2 text-gray-800">
                <div className="linkCol">
                  {col.render
                    ? col.render(value, row)
                    : (value as React.ReactNode)}
                </div>
              </td>
            );
          })}
        </tr>
      )),
    [data, columns]
  );

  return (
    <div className="overflow-x-auto rounded-lg shadow">
      <table className="min-w-full border border-gray-200 text-sm text-left">
        <thead className="bg-gray-100">
          <tr>{tableHeaders}</tr>
        </thead>
        <tbody>{tableRows}</tbody>
      </table>
    </div>
  );
};

export const Table = React.memo(TableComponent) as typeof TableComponent;
